(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["company-history-timeline"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.company-history-timeline-block').forEach((timeline) => {
    const items = timeline.querySelectorAll('.company-history-milestone-block');
    const details = timeline.querySelectorAll('.company-history-milestone-block__details');
    const autoExpand = timeline.dataset.scrollAutoExpand === 'true';
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    items.forEach((item) => revealObserver.observe(item));
    if (!autoExpand || details.length === 0) return;
    const openOnly = (active) => details.forEach((detail) => { detail.open = detail === active; });
    const activeObserver = new IntersectionObserver((entries) => {
      const activeEntry = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (!activeEntry) return;
      const activeDetail = activeEntry.target.querySelector('.company-history-milestone-block__details');
      if (activeDetail) openOnly(activeDetail);
    }, { rootMargin: '-35% 0px -45% 0px', threshold: [0.15, 0.3, 0.55, 0.8] });
    items.forEach((item) => activeObserver.observe(item));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["netum-quote-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-netum-quote-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.netumQuoteOpen);
      if (dialog && !dialog.open) dialog.showModal();
    }

    const closer = event.target.closest('[data-netum-quote-close]');
    if (closer) closer.closest('dialog')?.close();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["netum-quote-cta-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-netum-quote-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.netumQuoteOpen);
      if (dialog && !dialog.open) dialog.showModal();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
